import type { AiService } from '@/context/services/ai_service_setting/type';
import { useTranslation } from '@/i18n';
import { ButtonV2, TextLink } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, useState } from 'react';
import { ModelTrainingSetting } from '../ModelTrainingSetting/ModelTrainingSetting';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);
const AI_AGREEMENT_URL = 'https://biz.moneyforward.com/ai-agreement/';

type InitialSettingProps = {
  services: AiService[];
};

export const InitialSetting: FC<InitialSettingProps> = ({ services }) => {
  const { t } = useTranslation();
  const [isModelTrainingAllowed, setIsModelTrainingAllowed] = useState(false);

  return (
    <div className={cx('container')} data-testid='initial-setting'>
      <h1 className={cx('heading')}>
        {t('ai_service_setting.initial_heading')}
      </h1>
      <section className={cx('providedServices')}>
        <p>{t('ai_service_setting.provided_services_heading')}</p>
        <ul className={cx('providedServicesList')}>
          {services.map(({ description, name, service_type }) => (
            <li key={service_type}>
              <p>{name}</p>
              <p className={cx('caption')}>{description}</p>
            </li>
          ))}
        </ul>
      </section>
      <hr className={cx('divider')} />
      <div className={cx('agreementDescription')}>
        <p>{t('ai_service_setting.agreement_required')}</p>
        <TextLink href={AI_AGREEMENT_URL} target='_blank'>
          {t('ai_service_setting.agreement_link')}
        </TextLink>
      </div>
      <ModelTrainingSetting
        isAllowed={isModelTrainingAllowed}
        isInitial
        onChange={setIsModelTrainingAllowed}
      />
      <p className={cx('caption')}>
        {t('ai_service_setting.operation_notice')}
      </p>
      <ButtonV2 color='primary' size='sm' type='button'>
        {t('ai_service_setting.agree_and_start_button')}
      </ButtonV2>
    </div>
  );
};
